import TokenResource from "./TokenResource";

export default class DployTokenResource extends TokenResource {
	lockToApplicationToken = "";

	pk() {
		return "dployToken";
	}

	static currentShape() {
		return {
			...super.detailShape(),
			fetch: (params: any, body: object | string) => {
				return this.fetch("get", `${this.urlRoot}/${params.applicationNumber}`);
			},
		};
	}

	static urlRoot = "/api/dployToken";
}
